import React, { useRef, useEffect, } from 'react';
import './StyleButtons.css';

const StyleButtons = ({ onStyleChange, lowContrast, isInfo }) => {
  const containerRef = useRef(null);
  let isDown = false;
  let startX;
  let scrollLeft;

  useEffect(() => {
    const container = containerRef.current;

    const handleMouseDown = (e) => {
      if (!isTouchDevice()) return; // Only enable on touch devices
      isDown = true;
      container.classList.add('active');
      startX = e.pageX - container.offsetLeft;
      scrollLeft = container.scrollLeft;
    };

    const handleMouseLeave = () => {
      if (!isTouchDevice()) return; // Only enable on touch devices
      isDown = false;
      container.classList.remove('active');
    };

    const handleMouseUp = () => {
      if (!isTouchDevice()) return; // Only enable on touch devices
      isDown = false;
      container.classList.remove('active');
    };

    const handleMouseMove = (e) => {
      if (!isTouchDevice() || !isDown) return; // Only enable on touch devices
      e.preventDefault();
      const x = e.pageX - container.offsetLeft;
      const walk = (x - startX) * 3; // scroll-fast
      container.scrollLeft = scrollLeft - walk;
    };

    container.addEventListener('mousedown', handleMouseDown);
    container.addEventListener('mouseleave', handleMouseLeave);
    container.addEventListener('mouseup', handleMouseUp);
    container.addEventListener('mousemove', handleMouseMove);

    return () => {
      container.removeEventListener('mousedown', handleMouseDown);
      container.removeEventListener('mouseleave', handleMouseLeave);
      container.removeEventListener('mouseup', handleMouseUp);
      container.removeEventListener('mousemove', handleMouseMove);
    };
  }, []);

  const isTouchDevice = () => {
    return 'ontouchstart' in window || navigator.maxTouchPoints;
  };

  const handleStyleChange = (style) => {
    onStyleChange(style);
  };

  return (
    <div id="style-container" className={`style-container ${isInfo ? 'info' : 'noinfo'}`} ref={containerRef}>
      {isInfo && <div id='iField'><p>Wybierz Postać</p></div>}
      <button 
        className={`stylebutton ${lowContrast ? 'low-contrast' : 'normal-contrast'}`} 
        onClick={() => handleStyleChange('surferka')}
        onTouchStart={() => handleStyleChange('surferka')}
      >
        <p>Wolna Surferka</p>
      </button>
      <button 
        className={`stylebutton ${lowContrast ? 'low-contrast' : 'normal-contrast'}`} 
        onClick={() => handleStyleChange('powergirl')}
        onTouchStart={() => handleStyleChange('powergirl')}
      >
        <p>Power Girl</p>
      </button>
      <button 
        className={`stylebutton ${lowContrast ? 'low-contrast' : 'normal-contrast'}`} 
        onClick={() => handleStyleChange('aktywistka')}
        onTouchStart={() => handleStyleChange('aktywistka')}
      >
        <p>Zaangażowana Aktywistka</p>
      </button>
      <button 
        className={`stylebutton ${lowContrast ? 'low-contrast' : 'normal-contrast'}`} 
        onClick={() => handleStyleChange('tatuazysta')}
        onTouchStart={() => handleStyleChange('tatuazysta')}
      >
        <p>Wrażliwy Twórca</p>
      </button>
    </div>
  );
};

export default StyleButtons;
